import type { FunctionComponent, HTMLProps, ReactNode } from 'react'
import React from 'react'

import classnames from 'classnames'

import type { LinkAppearance } from '../../../types'
import type { BadgeTheme } from '../../Badge'
import { Badge } from '../../Badge'
import { Link } from '../../Link/Link'
import styles from './ProductLink.module.scss'

export const ProductLink: FunctionComponent<ProductLinkProps> = ({
  href = '',
  children,
  linkStyle = 'secondary',
  badgeTheme,
  badgeId = '',
  className,
  ...rest
}) => {
  const BadgeComponent = () => (
    <Badge
      theme={badgeTheme as BadgeTheme}
      data-testid={`product-link-${badgeId}-badge`}
    />
  )

  return (
    <Link
      href={href}
      appearance={linkStyle}
      includeIcon={false}
      className={classnames(styles.productLink, className)}
      data-testid={`product-link-${badgeId}`}
      {...(badgeTheme && { badge: BadgeComponent })}
      {...rest}
    >
      {children}
    </Link>
  )
}

///////// IMPLEMENTATION /////////

type ProductLinkProps = {
  children: ReactNode
  href?: string | null
  linkStyle?: LinkAppearance
  badgeTheme?: BadgeTheme
  badgeId?: string
  className?: string
} & HTMLProps<HTMLAnchorElement>
